import { IntlProvider } from 'dibs-react-intl';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay';
import serverVars from 'server-vars';
import { hydrateRoot } from 'react-dom/client';

import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { ContemporaryLandingRespLayout } from '../contemporaryLanding/ContemporaryLandingRespLayout.jsx';
import { contemporaryLandingRootQuery } from '../queries/contemporaryLandingRoot.js';
import { ContemporaryLandingContextProvider } from '../contemporaryLanding/ContemporaryLandingContext.js';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';

const ComponentWrapper = () => {
    const data = useLazyLoadQuery(contemporaryLandingRootQuery, serverVars.get('relayVariables'), {
        fetchPolicy: 'store-only',
    });

    return <ContemporaryLandingRespLayout viewer={data.viewer} />;
};

initializeDBL().then(() => {
    const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <RelayEnvironmentProvider environment={environment}>
                <ErrorBoundary fallback={() => <Error500Layout />}>
                    <ContemporaryLandingContextProvider
                        isMobile={serverVars.get('settings.isMobile')}
                        isTablet={serverVars.get('settings.isTablet')}
                        isDesktop={serverVars.get('settings.isDesktop')}
                        userType={serverVars.get('userType')}
                    >
                        <ComponentWrapper />
                    </ContemporaryLandingContextProvider>
                </ErrorBoundary>
            </RelayEnvironmentProvider>
        </IntlProvider>
    );
});
